
function Hero() {
    return (
        <section className="tt-hero" id="inicio">
            <div className="wrap">
                <div className="hero-copy">
                    <h1>
                        Traducción que <span className="accent">conecta al mundo</span>
                    </h1>

                    <p className="hero-sub">Tu aliado en comunicación global</p>

                    <div className="hero-badges">
                        <div className="hbadge">
                            <span className="ic">
                                <i className="fas fa-shield-alt"></i>
                            </span>
                            <div>
                                <b>Confidencialidad garantizada</b>
                                <span>Tus datos están protegidos</span>
                            </div>
                        </div>

                        <div className="hbadge">
                            <span className="ic">
                                <i className="fas fa-award"></i>
                            </span>
                            <div>
                                <b>Calidad certificada</b>
                                <span>Traductores profesionales colegiados</span>
                            </div>
                        </div>

                        <div className="hbadge">
                            <span className="ic">
                                <i className="fas fa-clock"></i>
                            </span>
                            <div>
                                <b>Puntualidad asegurada</b>
                                <span>Entregas a tiempo</span>
                            </div>
                        </div>
                    </div>

                    <div className="hero-ctas">
                        <a className="btn btn-gold" href="#contacto">
                            <i className="fas fa-paper-plane"></i> Solicitar cotización
                        </a>

                        <a className="btn btn-outline" href="#servicios">
                            <i className="fas fa-play-circle"></i> Conocer más
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;